import ThemedButton from './ThemedButton';

export default ThemedButton;
